
// services/facture.js
import { post } from './api';

export const envoyerFacture = async (client, commande, lignes) => {
  const payload = { client, commande, lignes };
  const res = await post('/email/send-facture', payload, {
    headers: { 'Content-Type': 'application/json' },
  });
  return res.data;
};

